import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
};

export enum Calendar_First_Direction {
  CommunityNativeFavorite = 'COMMUNITY_NATIVE_FAVORITE',
  CultureAndArt = 'CULTURE_AND_ART',
  DiplomacyAndInternationalRelations = 'DIPLOMACY_AND_INTERNATIONAL_RELATIONS',
  EcologyAndNatureProtection = 'ECOLOGY_AND_NATURE_PROTECTION',
  EducationAndKnowledge = 'EDUCATION_AND_KNOWLEDGE',
  HealthyLifestyle = 'HEALTHY_LIFESTYLE',
  MediaAndCommunications = 'MEDIA_AND_COMMUNICATIONS',
  PatriotismAndHistoricalMemory = 'PATRIOTISM_AND_HISTORICAL_MEMORY',
  ScienceAndTechnology = 'SCIENCE_AND_TECHNOLOGY',
  Sport = 'SPORT',
  TourismAndTravel = 'TOURISM_AND_TRAVEL',
  Volunteering = 'VOLUNTEERING',
  WorkProfessionAndOwnBusiness = 'WORK_PROFESSION_AND_OWN_BUSINESS'
}

export enum Category_File_Type {
  BannerDesktop = 'BANNER_DESKTOP',
  BannerMobile = 'BANNER_MOBILE',
  Regular = 'REGULAR'
}

export type Category = {
  __typename?: 'Category';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  files?: Maybe<Array<CategoryFile>>;
  id: Scalars['ID']['output'];
  subcategories?: Maybe<Array<Subcategory>>;
  title: Scalars['String']['output'];
  type: Material_Type;
  updatedAt: Scalars['Date']['output'];
};

export type CategoryFile = {
  __typename?: 'CategoryFile';
  category: Category;
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  file: File;
  fileId: Scalars['ID']['output'];
  fileType: Category_File_Type;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CategoryFileFilterInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CategoryFilePlatformDto = {
  __typename?: 'CategoryFilePlatformDto';
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  file: FilePlatformDto;
  fileId: Scalars['ID']['output'];
  fileType: Category_File_Type;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CategoryFileSearchItemDto = {
  __typename?: 'CategoryFileSearchItemDto';
  contextName?: Maybe<Scalars['String']['output']>;
  file: FilePlatformDto;
  source: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['ID']['output']>;
};

export type CategoryFilterInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Material_Type>;
};

export type CategoryPlatformDto = {
  __typename?: 'CategoryPlatformDto';
  createdAt: Scalars['Date']['output'];
  files?: Maybe<Array<CategoryFilePlatformDto>>;
  id: Scalars['ID']['output'];
  subcategories?: Maybe<Array<PlainSubcategoryPlatformDto>>;
  title: Scalars['String']['output'];
  type: Material_Type;
  updatedAt: Scalars['Date']['output'];
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type FilePlatformDto = {
  __typename?: 'FilePlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type Keyword = {
  __typename?: 'Keyword';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  materials?: Maybe<Array<MaterialKeyword>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KeywordFilterInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type KeywordPlatformDto = {
  __typename?: 'KeywordPlatformDto';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum Material_File_Type {
  Recommendation = 'RECOMMENDATION',
  Regular = 'REGULAR'
}

export enum Material_Type {
  KnowledgeBase = 'KNOWLEDGE_BASE',
  Material = 'MATERIAL'
}

export type Material = {
  __typename?: 'Material';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  files?: Maybe<Array<MaterialFile>>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['String']['output'];
  keywords?: Maybe<Array<MaterialKeyword>>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  specialView?: Maybe<Scalars['Boolean']['output']>;
  subcategory?: Maybe<Subcategory>;
  subcategoryId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: Material_Type;
  updatedAt: Scalars['Date']['output'];
  versions?: Maybe<Array<MaterialVersion>>;
};

export type MaterialFile = {
  __typename?: 'MaterialFile';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  direction?: Maybe<Calendar_First_Direction>;
  file: File;
  fileId: Scalars['ID']['output'];
  fileType: Material_File_Type;
  id: Scalars['ID']['output'];
  material: Material;
  materialId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  orderPath: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MaterialFileFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialFilePlatformDto = {
  __typename?: 'MaterialFilePlatformDto';
  createdAt: Scalars['Date']['output'];
  direction?: Maybe<Calendar_First_Direction>;
  file: FilePlatformDto;
  fileId: Scalars['ID']['output'];
  fileType: Material_File_Type;
  id: Scalars['ID']['output'];
  materialId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['String']['output'];
  orderPath: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MaterialFilterInput = {
  categoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywordsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['Date']['input']>;
  publishedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  publishedAtTo?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subcategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Material_Type>;
};

export type MaterialKeyword = {
  __typename?: 'MaterialKeyword';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  keyword: Keyword;
  keywordId: Scalars['ID']['output'];
  material: Material;
  materialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MaterialKeywordPlatformDto = {
  __typename?: 'MaterialKeywordPlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  keyword: KeywordPlatformDto;
  keywordId: Scalars['ID']['output'];
  materialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MaterialPlatformDto = {
  __typename?: 'MaterialPlatformDto';
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<MaterialVersionPlatformDto>;
  description: Scalars['String']['output'];
  files?: Maybe<Array<MaterialFilePlatformDto>>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['String']['output'];
  keywords?: Maybe<Array<MaterialKeywordPlatformDto>>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  specialView?: Maybe<Scalars['Boolean']['output']>;
  subcategory?: Maybe<SubcategoryPlatformDto>;
  subcategoryId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: Material_Type;
  updatedAt: Scalars['Date']['output'];
};

export type MaterialVersion = {
  __typename?: 'MaterialVersion';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  material: Material;
  materialId: Scalars['ID']['output'];
  order: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MaterialVersionPlatformDto = {
  __typename?: 'MaterialVersionPlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  materialId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum Permission_Action {
  KnowledgeBaseManagement = 'knowledge_base_management',
  KnowledgeBaseUpdate = 'knowledge_base_update',
  MaterialManagement = 'material_management',
  MaterialUpdate = 'material_update',
  QuestionManagement = 'question_management',
  QuestionUpdate = 'question_update',
  UserAdministration = 'user_administration'
}

export type PaginatedCategoryPlatformDto = {
  __typename?: 'PaginatedCategoryPlatformDto';
  data?: Maybe<Array<CategoryPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedKeywordPlatformDto = {
  __typename?: 'PaginatedKeywordPlatformDto';
  data?: Maybe<Array<KeywordPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedMaterialPlatformDto = {
  __typename?: 'PaginatedMaterialPlatformDto';
  data?: Maybe<Array<MaterialPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedQuestionCategoryAdminDto = {
  __typename?: 'PaginatedQuestionCategoryAdminDto';
  data?: Maybe<Array<QuestionCategoryPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedQuestionPlatformDto = {
  __typename?: 'PaginatedQuestionPlatformDto';
  data?: Maybe<Array<QuestionPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedSubcategoryPlatformDto = {
  __typename?: 'PaginatedSubcategoryPlatformDto';
  data?: Maybe<Array<SubcategoryPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginatedTagPlatformDto = {
  __typename?: 'PaginatedTagPlatformDto';
  data?: Maybe<Array<TagPlatformDto>>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export type PaginationInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  action: Permission_Action;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  users?: Maybe<Array<UserPermission>>;
};

export type PlainSubcategoryPlatformDto = {
  __typename?: 'PlainSubcategoryPlatformDto';
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type Query = {
  __typename?: 'Query';
  categories: PaginatedCategoryPlatformDto;
  categoryFiles: Array<CategoryFileSearchItemDto>;
  keywords: PaginatedKeywordPlatformDto;
  material: MaterialPlatformDto;
  materialFiles: Array<MaterialFilePlatformDto>;
  materials: PaginatedMaterialPlatformDto;
  question: QuestionPlatformDto;
  questionCategories: PaginatedQuestionCategoryAdminDto;
  questions: PaginatedQuestionPlatformDto;
  subcategories: PaginatedSubcategoryPlatformDto;
  tags: PaginatedTagPlatformDto;
};


export type QueryCategoriesArgs = {
  filter: CategoryFilterInput;
  pagination: PaginationInput;
};


export type QueryCategoryFilesArgs = {
  categoryId: Scalars['ID']['input'];
  filter?: InputMaybe<CategoryFileFilterInput>;
};


export type QueryKeywordsArgs = {
  filter: KeywordFilterInput;
  pagination: PaginationInput;
};


export type QueryMaterialArgs = {
  materialId: Scalars['ID']['input'];
};


export type QueryMaterialFilesArgs = {
  filter?: InputMaybe<MaterialFileFilterInput>;
  materialId: Scalars['ID']['input'];
};


export type QueryMaterialsArgs = {
  filter: MaterialFilterInput;
  pagination: PaginationInput;
};


export type QueryQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type QueryQuestionCategoriesArgs = {
  filter: QuestionCategoriesFilterInput;
  pagination: PaginationInput;
};


export type QueryQuestionsArgs = {
  filter: QuestionFilterInput;
  pagination: PaginationInput;
};


export type QuerySubcategoriesArgs = {
  filter: SubcategoryFilterInput;
  pagination: PaginationInput;
};


export type QueryTagsArgs = {
  filter: TagFilterInput;
  pagination: PaginationInput;
};

export type Question = {
  __typename?: 'Question';
  answerText: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  documents?: Maybe<Array<QuestionDocument>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Date']['output'];
  isHidden: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  questionText: Scalars['String']['output'];
  tags?: Maybe<Array<QuestionTag>>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionCategoriesFilterInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionCategory = {
  __typename?: 'QuestionCategory';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<QuestionSubcategory>>;
  systemArchive: Scalars['String']['output'];
  tags?: Maybe<Array<Tag>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionCategoryPlatformDto = {
  __typename?: 'QuestionCategoryPlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  subcategories?: Maybe<Array<QuestionSubcategory>>;
  systemArchive: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionDocument = {
  __typename?: 'QuestionDocument';
  audiences?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  file: File;
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  question: Question;
  questionId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<QuestionDocumentType>;
  typeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionDocumentType = {
  __typename?: 'QuestionDocumentType';
  color: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionFilterInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  publishedAtTo?: InputMaybe<Scalars['Date']['input']>;
  questionCategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionSubCategoriesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuestionPlatformDto = {
  __typename?: 'QuestionPlatformDto';
  answerText: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  documents?: Maybe<Array<QuestionDocument>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Date']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  questionText: Scalars['String']['output'];
  tags?: Maybe<Array<QuestionTagPlatformDto>>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionSubcategory = {
  __typename?: 'QuestionSubcategory';
  category: QuestionCategory;
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tag>>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionSubcategoryPlatformDto = {
  __typename?: 'QuestionSubcategoryPlatformDto';
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  question: Question;
  questionId: Scalars['ID']['output'];
  tag: Tag;
  tagId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionTagPlatformDto = {
  __typename?: 'QuestionTagPlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  tag: TagPlatformDto;
  tagId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type Subcategory = {
  __typename?: 'Subcategory';
  category: Category;
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  materials?: Maybe<Array<Material>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SubcategoryFilterInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryType?: InputMaybe<Material_Type>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubcategoryPlatformDto = {
  __typename?: 'SubcategoryPlatformDto';
  category: CategoryPlatformDto;
  categoryId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  questionCategory: QuestionCategory;
  questionCategoryId: Scalars['ID']['output'];
  questionSubcategory?: Maybe<QuestionSubcategory>;
  questionSubcategoryId: Scalars['ID']['output'];
  questions?: Maybe<Array<QuestionTag>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TagFilterInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  questionCategoryId?: InputMaybe<Scalars['ID']['input']>;
  questionSubCategoryId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TagPlatformDto = {
  __typename?: 'TagPlatformDto';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  questionCategory: QuestionCategoryPlatformDto;
  questionCategoryId: Scalars['ID']['output'];
  questionSubcategory?: Maybe<QuestionSubcategoryPlatformDto>;
  questionSubcategoryId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_blocked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<UserPermission>>;
  updatedAt: Scalars['Date']['output'];
};

export type UserPermission = {
  __typename?: 'UserPermission';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  permission: Permission;
  permissionId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type QuestionCategoriesQueryVariables = Exact<{
  filter?: QuestionCategoriesFilterInput;
  pagination?: PaginationInput;
}>;


export type QuestionCategoriesQuery = { __typename?: 'Query', questionCategories: { __typename?: 'PaginatedQuestionCategoryAdminDto', data?: Array<{ __typename?: 'QuestionCategoryPlatformDto', id: string, title: string, subcategories?: Array<{ __typename?: 'QuestionSubcategory', id: string, name: string, position?: string | null, categoryId: string }> | null }> | null } };

export type QuestionsQueryVariables = Exact<{
  filter: QuestionFilterInput;
  pagination: PaginationInput;
}>;


export type QuestionsQuery = { __typename?: 'Query', questions: { __typename?: 'PaginatedQuestionPlatformDto', totalCount: number, data?: Array<{ __typename?: 'QuestionPlatformDto', id: string, answerText: string, questionText: string, isArchived: any, tags?: Array<{ __typename?: 'QuestionTagPlatformDto', id: string, tag: { __typename?: 'TagPlatformDto', id: string, title: string } }> | null, documents?: Array<{ __typename?: 'QuestionDocument', id: string, title: string, publishedAt?: any | null, audiences?: Array<string> | null, type?: { __typename?: 'QuestionDocumentType', color: string, title: string } | null, file: { __typename?: 'File', id: string, name: string, url: string } }> | null }> | null } };

export type TagsQueryVariables = Exact<{
  filter?: TagFilterInput;
  pagination?: PaginationInput;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'PaginatedTagPlatformDto', data?: Array<{ __typename?: 'TagPlatformDto', id: string, title: string, questionCategory: { __typename?: 'QuestionCategoryPlatformDto', id: string, title: string } }> | null } };

export type CategoriesQueryVariables = Exact<{
  filter?: CategoryFilterInput;
  pagination: PaginationInput;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: { __typename?: 'PaginatedCategoryPlatformDto', totalCount: number, data?: Array<{ __typename?: 'CategoryPlatformDto', id: string, title: string, subcategories?: Array<{ __typename?: 'PlainSubcategoryPlatformDto', id: string, title: string }> | null }> | null } };

export type CategoryFilesQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
  filter?: InputMaybe<CategoryFileFilterInput>;
}>;


export type CategoryFilesQuery = { __typename?: 'Query', categoryFiles: Array<{ __typename?: 'CategoryFileSearchItemDto', source: string, sourceId?: string | null, contextName?: string | null, file: { __typename?: 'FilePlatformDto', id: string, name: string, url: string } }> };

export type KeywordsQueryVariables = Exact<{
  filter: KeywordFilterInput;
  pagination: PaginationInput;
}>;


export type KeywordsQuery = { __typename?: 'Query', keywords: { __typename?: 'PaginatedKeywordPlatformDto', totalCount: number, data?: Array<{ __typename?: 'KeywordPlatformDto', id: string, title: string }> | null } };

export type MaterialQueryVariables = Exact<{
  materialId: Scalars['ID']['input'];
}>;


export type MaterialQuery = { __typename?: 'Query', material: { __typename?: 'MaterialPlatformDto', id: string, type: Material_Type, publishedAt?: any | null, title: string, keywords?: Array<{ __typename?: 'MaterialKeywordPlatformDto', id: string, keyword: { __typename?: 'KeywordPlatformDto', id: string, title: string } }> | null, currentVersion?: { __typename?: 'MaterialVersionPlatformDto', id: string, text: string } | null, subcategory?: { __typename?: 'SubcategoryPlatformDto', id: string, title: string, category: { __typename?: 'CategoryPlatformDto', id: string, title: string, files?: Array<{ __typename?: 'CategoryFilePlatformDto', id: string, fileType: Category_File_Type, file: { __typename?: 'FilePlatformDto', id: string, url: string, name: string } }> | null } } | null, files?: Array<{ __typename?: 'MaterialFilePlatformDto', id: string, name: string, fileType: Material_File_Type, direction?: Calendar_First_Direction | null, order: string, path: string, file: { __typename?: 'FilePlatformDto', id: string, url: string, name: string } }> | null } };

export type MaterialFilesQueryVariables = Exact<{
  materialId: Scalars['ID']['input'];
  filter?: InputMaybe<MaterialFileFilterInput>;
}>;


export type MaterialFilesQuery = { __typename?: 'Query', materialFiles: Array<{ __typename?: 'MaterialFilePlatformDto', id: string, name: string, fileType: Material_File_Type, direction?: Calendar_First_Direction | null, order: string, path: string, file: { __typename?: 'FilePlatformDto', id: string, url: string, name: string } }> };

export type MaterialsQueryVariables = Exact<{
  filter?: MaterialFilterInput;
  pagination: PaginationInput;
}>;


export type MaterialsQuery = { __typename?: 'Query', materials: { __typename?: 'PaginatedMaterialPlatformDto', totalCount: number, data?: Array<{ __typename?: 'MaterialPlatformDto', id: string, createdAt: any, publishedAt?: any | null, description: string, title: string, specialView?: boolean | null, keywords?: Array<{ __typename?: 'MaterialKeywordPlatformDto', id: string, keyword: { __typename?: 'KeywordPlatformDto', id: string, title: string } }> | null }> | null } };

export type SubcategoriesQueryVariables = Exact<{
  filter: SubcategoryFilterInput;
  pagination: PaginationInput;
}>;


export type SubcategoriesQuery = { __typename?: 'Query', subcategories: { __typename?: 'PaginatedSubcategoryPlatformDto', totalCount: number, data?: Array<{ __typename?: 'SubcategoryPlatformDto', id: string, title: string, category: { __typename?: 'CategoryPlatformDto', id: string, title: string } }> | null } };


export const QuestionCategoriesDocument = gql`
    query questionCategories($filter: QuestionCategoriesFilterInput! = {}, $pagination: PaginationInput! = {page: 0, limit: 1000}) {
  questionCategories(filter: $filter, pagination: $pagination) {
    data {
      id
      title
      subcategories {
        id
        name
        position
        categoryId
      }
    }
  }
}
    `;

/**
 * __useQuestionCategoriesQuery__
 *
 * To run a query within a React component, call `useQuestionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useQuestionCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>(QuestionCategoriesDocument, options);
      }
export function useQuestionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>(QuestionCategoriesDocument, options);
        }
export function useQuestionCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>(QuestionCategoriesDocument, options);
        }
export type QuestionCategoriesQueryHookResult = ReturnType<typeof useQuestionCategoriesQuery>;
export type QuestionCategoriesLazyQueryHookResult = ReturnType<typeof useQuestionCategoriesLazyQuery>;
export type QuestionCategoriesSuspenseQueryHookResult = ReturnType<typeof useQuestionCategoriesSuspenseQuery>;
export type QuestionCategoriesQueryResult = Apollo.QueryResult<QuestionCategoriesQuery, QuestionCategoriesQueryVariables>;
export const QuestionsDocument = gql`
    query questions($filter: QuestionFilterInput!, $pagination: PaginationInput!) {
  questions(filter: $filter, pagination: $pagination) {
    totalCount
    data {
      id
      answerText
      questionText
      isArchived
      tags {
        id
        tag {
          id
          title
        }
      }
      documents {
        id
        title
        publishedAt
        type {
          color
          title
        }
        audiences
        file {
          id
          name
          url
        }
      }
    }
  }
}
    `;

/**
 * __useQuestionsQuery__
 *
 * To run a query within a React component, call `useQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useQuestionsQuery(baseOptions: Apollo.QueryHookOptions<QuestionsQuery, QuestionsQueryVariables> & ({ variables: QuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
      }
export function useQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export function useQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionsQuery, QuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionsQuery, QuestionsQueryVariables>(QuestionsDocument, options);
        }
export type QuestionsQueryHookResult = ReturnType<typeof useQuestionsQuery>;
export type QuestionsLazyQueryHookResult = ReturnType<typeof useQuestionsLazyQuery>;
export type QuestionsSuspenseQueryHookResult = ReturnType<typeof useQuestionsSuspenseQuery>;
export type QuestionsQueryResult = Apollo.QueryResult<QuestionsQuery, QuestionsQueryVariables>;
export const TagsDocument = gql`
    query tags($filter: TagFilterInput! = {}, $pagination: PaginationInput! = {page: 0, limit: 10}) {
  tags(filter: $filter, pagination: $pagination) {
    data {
      id
      title
      questionCategory {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const CategoriesDocument = gql`
    query categories($filter: CategoryFilterInput! = {}, $pagination: PaginationInput!) {
  categories(filter: $filter, pagination: $pagination) {
    totalCount
    data {
      id
      title
      subcategories {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables> & ({ variables: CategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export function useCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesSuspenseQueryHookResult = ReturnType<typeof useCategoriesSuspenseQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryFilesDocument = gql`
    query categoryFiles($categoryId: ID!, $filter: CategoryFileFilterInput) {
  categoryFiles(categoryId: $categoryId, filter: $filter) {
    source
    sourceId
    contextName
    file {
      id
      name
      url
    }
  }
}
    `;

/**
 * __useCategoryFilesQuery__
 *
 * To run a query within a React component, call `useCategoryFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryFilesQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCategoryFilesQuery(baseOptions: Apollo.QueryHookOptions<CategoryFilesQuery, CategoryFilesQueryVariables> & ({ variables: CategoryFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryFilesQuery, CategoryFilesQueryVariables>(CategoryFilesDocument, options);
      }
export function useCategoryFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryFilesQuery, CategoryFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryFilesQuery, CategoryFilesQueryVariables>(CategoryFilesDocument, options);
        }
export function useCategoryFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryFilesQuery, CategoryFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryFilesQuery, CategoryFilesQueryVariables>(CategoryFilesDocument, options);
        }
export type CategoryFilesQueryHookResult = ReturnType<typeof useCategoryFilesQuery>;
export type CategoryFilesLazyQueryHookResult = ReturnType<typeof useCategoryFilesLazyQuery>;
export type CategoryFilesSuspenseQueryHookResult = ReturnType<typeof useCategoryFilesSuspenseQuery>;
export type CategoryFilesQueryResult = Apollo.QueryResult<CategoryFilesQuery, CategoryFilesQueryVariables>;
export const KeywordsDocument = gql`
    query keywords($filter: KeywordFilterInput!, $pagination: PaginationInput!) {
  keywords(filter: $filter, pagination: $pagination) {
    totalCount
    data {
      id
      title
    }
  }
}
    `;

/**
 * __useKeywordsQuery__
 *
 * To run a query within a React component, call `useKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeywordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useKeywordsQuery(baseOptions: Apollo.QueryHookOptions<KeywordsQuery, KeywordsQueryVariables> & ({ variables: KeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeywordsQuery, KeywordsQueryVariables>(KeywordsDocument, options);
      }
export function useKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeywordsQuery, KeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeywordsQuery, KeywordsQueryVariables>(KeywordsDocument, options);
        }
export function useKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KeywordsQuery, KeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KeywordsQuery, KeywordsQueryVariables>(KeywordsDocument, options);
        }
export type KeywordsQueryHookResult = ReturnType<typeof useKeywordsQuery>;
export type KeywordsLazyQueryHookResult = ReturnType<typeof useKeywordsLazyQuery>;
export type KeywordsSuspenseQueryHookResult = ReturnType<typeof useKeywordsSuspenseQuery>;
export type KeywordsQueryResult = Apollo.QueryResult<KeywordsQuery, KeywordsQueryVariables>;
export const MaterialDocument = gql`
    query material($materialId: ID!) {
  material(materialId: $materialId) {
    id
    type
    publishedAt
    title
    keywords {
      id
      keyword {
        id
        title
      }
    }
    currentVersion {
      id
      text
    }
    subcategory {
      id
      title
      category {
        id
        title
        files {
          id
          fileType
          file {
            id
            url
            name
          }
        }
      }
    }
    files {
      id
      name
      fileType
      direction
      order
      path
      file {
        id
        url
        name
      }
    }
  }
}
    `;

/**
 * __useMaterialQuery__
 *
 * To run a query within a React component, call `useMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *   },
 * });
 */
export function useMaterialQuery(baseOptions: Apollo.QueryHookOptions<MaterialQuery, MaterialQueryVariables> & ({ variables: MaterialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialQuery, MaterialQueryVariables>(MaterialDocument, options);
      }
export function useMaterialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialQuery, MaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialQuery, MaterialQueryVariables>(MaterialDocument, options);
        }
export function useMaterialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialQuery, MaterialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialQuery, MaterialQueryVariables>(MaterialDocument, options);
        }
export type MaterialQueryHookResult = ReturnType<typeof useMaterialQuery>;
export type MaterialLazyQueryHookResult = ReturnType<typeof useMaterialLazyQuery>;
export type MaterialSuspenseQueryHookResult = ReturnType<typeof useMaterialSuspenseQuery>;
export type MaterialQueryResult = Apollo.QueryResult<MaterialQuery, MaterialQueryVariables>;
export const MaterialFilesDocument = gql`
    query materialFiles($materialId: ID!, $filter: MaterialFileFilterInput) {
  materialFiles(materialId: $materialId, filter: $filter) {
    id
    name
    fileType
    direction
    order
    path
    file {
      id
      url
      name
    }
  }
}
    `;

/**
 * __useMaterialFilesQuery__
 *
 * To run a query within a React component, call `useMaterialFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialFilesQuery({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMaterialFilesQuery(baseOptions: Apollo.QueryHookOptions<MaterialFilesQuery, MaterialFilesQueryVariables> & ({ variables: MaterialFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialFilesQuery, MaterialFilesQueryVariables>(MaterialFilesDocument, options);
      }
export function useMaterialFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialFilesQuery, MaterialFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialFilesQuery, MaterialFilesQueryVariables>(MaterialFilesDocument, options);
        }
export function useMaterialFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialFilesQuery, MaterialFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialFilesQuery, MaterialFilesQueryVariables>(MaterialFilesDocument, options);
        }
export type MaterialFilesQueryHookResult = ReturnType<typeof useMaterialFilesQuery>;
export type MaterialFilesLazyQueryHookResult = ReturnType<typeof useMaterialFilesLazyQuery>;
export type MaterialFilesSuspenseQueryHookResult = ReturnType<typeof useMaterialFilesSuspenseQuery>;
export type MaterialFilesQueryResult = Apollo.QueryResult<MaterialFilesQuery, MaterialFilesQueryVariables>;
export const MaterialsDocument = gql`
    query materials($filter: MaterialFilterInput! = {}, $pagination: PaginationInput!) {
  materials(filter: $filter, pagination: $pagination) {
    totalCount
    data {
      id
      createdAt
      publishedAt
      description
      title
      specialView
      keywords {
        id
        keyword {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useMaterialsQuery__
 *
 * To run a query within a React component, call `useMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMaterialsQuery(baseOptions: Apollo.QueryHookOptions<MaterialsQuery, MaterialsQueryVariables> & ({ variables: MaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialsQuery, MaterialsQueryVariables>(MaterialsDocument, options);
      }
export function useMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialsQuery, MaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialsQuery, MaterialsQueryVariables>(MaterialsDocument, options);
        }
export function useMaterialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialsQuery, MaterialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialsQuery, MaterialsQueryVariables>(MaterialsDocument, options);
        }
export type MaterialsQueryHookResult = ReturnType<typeof useMaterialsQuery>;
export type MaterialsLazyQueryHookResult = ReturnType<typeof useMaterialsLazyQuery>;
export type MaterialsSuspenseQueryHookResult = ReturnType<typeof useMaterialsSuspenseQuery>;
export type MaterialsQueryResult = Apollo.QueryResult<MaterialsQuery, MaterialsQueryVariables>;
export const SubcategoriesDocument = gql`
    query subcategories($filter: SubcategoryFilterInput!, $pagination: PaginationInput!) {
  subcategories(filter: $filter, pagination: $pagination) {
    totalCount
    data {
      id
      title
      category {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useSubcategoriesQuery__
 *
 * To run a query within a React component, call `useSubcategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSubcategoriesQuery(baseOptions: Apollo.QueryHookOptions<SubcategoriesQuery, SubcategoriesQueryVariables> & ({ variables: SubcategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubcategoriesQuery, SubcategoriesQueryVariables>(SubcategoriesDocument, options);
      }
export function useSubcategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubcategoriesQuery, SubcategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubcategoriesQuery, SubcategoriesQueryVariables>(SubcategoriesDocument, options);
        }
export function useSubcategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubcategoriesQuery, SubcategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubcategoriesQuery, SubcategoriesQueryVariables>(SubcategoriesDocument, options);
        }
export type SubcategoriesQueryHookResult = ReturnType<typeof useSubcategoriesQuery>;
export type SubcategoriesLazyQueryHookResult = ReturnType<typeof useSubcategoriesLazyQuery>;
export type SubcategoriesSuspenseQueryHookResult = ReturnType<typeof useSubcategoriesSuspenseQuery>;
export type SubcategoriesQueryResult = Apollo.QueryResult<SubcategoriesQuery, SubcategoriesQueryVariables>;